'use strict';
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/symbol-registry-detection.js
// module id = 558
// module chunks = 0